import { Lock } from 'lucide-react'
import {
  COMMERCIAL_ROWS,
  PARTNER_ROWS,
  RP_CONTRACT_LOCK,
} from './commercialStandard'

export function ComissoesStandardPanel({ commercialName }: { commercialName: string }) {
  return (
    <section className='space-y-4 rounded-xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-5'>
      <div>
        <p className='text-[11px] font-medium uppercase tracking-wider text-[var(--font-color-label)]'>Padrão de remuneração</p>
        <h3 className='mt-1 text-base font-semibold text-[var(--text-primary)]'>
          {commercialName} · Comercial Rocket
        </h3>
        <p className='mt-1 text-[13px] text-[var(--text-muted)]'>
          Tipo de valor: fixo + comissão. A comissão muda conforme a origem da venda e não se escolhe na conversão do lead.
        </p>
      </div>

      <RuleTable title='Comissão do comercial Rocket' rows={COMMERCIAL_ROWS} />
      <RuleTable title='Comissão do parceiro externo' rows={PARTNER_ROWS} />

      <p className='flex items-start gap-2 rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2 text-[12px] leading-relaxed text-[var(--text-primary)]'>
        <Lock size={14} className='mt-0.5 shrink-0 text-accent' aria-hidden />
        <span>
          <span className='font-semibold'>Indicador. </span>
          {RP_CONTRACT_LOCK}
        </span>
      </p>
    </section>
  )
}

function RuleTable({ title, rows }: { title: string; rows: readonly { origin: string; value: string }[] }) {
  return (
    <div>
      <h4 className='mb-2 text-[12px] font-semibold uppercase tracking-wider text-[var(--text-muted)]'>{title}</h4>
      <div className='overflow-hidden rounded-lg border border-[var(--glass-border)]'>
        {rows.map((row) => (
          <div key={row.origin} className='flex items-center justify-between gap-3 border-t border-[var(--glass-border)] px-3 py-2 text-[13px] first:border-t-0'>
            <span className='text-[var(--text-primary)]'>{row.origin}</span>
            <span className='text-right text-[var(--text-muted)]'>{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
